import { MutationHookOptions, MutationTuple, useMutation } from '@apollo/client'
import {
  ICreateOrderMutationParams,
  ICreateOrderMutationResponse,
} from './types'
import createOrderMutation from './mutation'

/**
 * Hook declaration for the `createOrder` mutation.
 *
 * `no-cache` like `prefillCart`: the returned order is written into
 * `ordersSlice` and then replaced by poll ticks that run `network-only`, so a
 * normalised copy here would only be a second, staler home for the same
 * entity.
 * @internal
 */
/*
 * ⚠️ **Do not set `errorPolicy: 'all'` or an `onError` handler here.**
 *
 * Under the default policy the mutate function *rejects*, and
 * `useOrderConfirmation` reads every failure in its catch — which is where a
 * checkout-rule rejection's `extras` are lifted into the rule types the screen
 * routes on. Either of those options makes the mutation resolve with
 * `FetchResult.errors` instead, at which point the catch never runs,
 * `result.data.createOrder` is null, and a rule rejection reports as a plain
 * creation failure with nothing to route to.
 */
const useCreateOrderMutation = (
  options?: MutationHookOptions<
    ICreateOrderMutationResponse,
    ICreateOrderMutationParams
  >,
): MutationTuple<ICreateOrderMutationResponse, ICreateOrderMutationParams> => {
  return useMutation<ICreateOrderMutationResponse, ICreateOrderMutationParams>(
    createOrderMutation,
    {
      fetchPolicy: 'no-cache',
      ...options,
    },
  )
}

export default useCreateOrderMutation
